<template>
  <div class="lectureAuditDetail">
    <el-form label-width="130px" :model="dataForm">
      <el-form-item label="标题：">
        {{ dataForm.Title }}
      </el-form-item>
      <el-form-item label="联系人：">
        {{ dataForm.Contacts }}
      </el-form-item>
      <el-form-item label="联系电话：">
        {{ dataForm.Phone }}
      </el-form-item>
      <el-form-item label="讲座类型：">
        {{ dataForm.LectureType === 0?'公益':'收费' }}
      </el-form-item>
      <el-form-item label="讲座地点：" v-if="dataForm.LectureType === 0">
        {{ dataForm.Address }}
      </el-form-item>
      <el-form-item label="讲座时间：" v-if="dataForm.LectureType === 0">
        {{ (dataForm.StartTime * 1000) | formatDate }}
      </el-form-item>
      <el-form-item
        label="收费费用(元)："
        v-if="dataForm.LectureType === 1"
      >
        {{ dataForm.GroupCost }}
      </el-form-item>
      <el-form-item
        label="学员名额(人)："
        v-if="dataForm.LectureType === 0"
      >
        {{ dataForm.StuPlaces }}
      </el-form-item>
      <el-form-item label="报名须知：">
        {{ dataForm.Condition }}
      </el-form-item>
      <el-form-item label="封面图：" v-if="headImage.FileName">
        <el-row>
            <el-col :span="20">{{headImage.FileName}}</el-col>
            <el-col :span="4">
                <el-button type="text" @click="showImageViewer">查看</el-button>
                <el-button type="text" @click="download">下载</el-button>
            </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="讲座介绍：" style="margin-top: 10px">
        <of-tinymce
          ref="editor"
          v-model="dataForm.Abstract"
          :height="500"
          :isEdit="true"
        ></of-tinymce>
      </el-form-item>
    </el-form>
    <imageViewer v-if="isShowImageViewe" :imageViewerUrl="imageViewerUrl" @closeImageViewer="closeImageViewer" />
  </div>
</template>
<script>
import OfTinymce from "@/components/controls/of_editor/of_tinymce_readonly";
import imageViewer from "@/components/controls/of_imageViewer";
import api from "@/modules/zjrc/api";
import { saveAs } from "file-saver";
export default {
  name: "lifeGuardAuditDetail",
  props: {
    dataForm: {
      type: Object,
      default: null,
    },
  },
  data(){
      return{
          headImage: {},
          isShowImageViewe: false,
          imageViewerUrl: ''
      }
  },
  components: {
    OfTinymce,
    imageViewer
  },
  mounted(){
      const vm = this
      vm.getHeadImge()
  },
  methods:{
      closeImageViewer(){
          const vm = this
          vm.isShowImageViewe = false
      },
      download(){
          const vm = this
          saveAs('/files' + vm.headImage.StorePath,vm.headImage.FileName)
      },
      showImageViewer(){
          const vm = this
          vm.imageViewerUrl = '/files' + vm.headImage.StorePath
          vm.isShowImageViewe = true
      },
      getHeadImge(){
          const vm = this
          const request = {id: vm.dataForm.HeadImge}
          api.QueryBigSickApplyFileByIds(request).then(res=>{
              if(res.data.Code === 0 && res.data.Data !== null && res.data.Data.length > 0){
                  vm.headImage = res.data.Data[0]
              }
          })
      }
  }
};
</script>
<style lang="scss" scoped>
.lectureAuditDetail{
    padding: 10px;
}
</style>